<template>
  <div
    v-tooltip="eventTooltip"
    class="day-event"
    :class="{ 'a-tooltip': showImportedTimeOffBadge }"
    :aria-label="bambooHrEventAriaLabel"
    :style="defaultStyle"
    :data-testid="showImportedTimeOffBadge ? 'schedules-time-off-event' : null"
  >
    <div class="img">
      <i
        v-if="type === 'Holiday'"
        class="hi hi-icon hi-20 hi-time-off"
      />
      <img
        v-else
        :src="avatar"
      />
    </div>
    <div class="event-details">
      <div class="name d-flex align-items-center min-w-0">
        <span class="text-truncate">{{ userRealName }}</span>
      </div>
      <div class="d-flex align-items-center min-w-0">
        <span class="event-details">{{ eventDetails }}</span>
        <TimeOffRequestBambooHrBadge
          v-if="showImportedTimeOffBadge"
          class="ml-5"
        />
      </div>
    </div>
    <div class="all-day">
      <span v-if="allDay">All day</span>
    </div>
    <div
      v-if="shiftSpillover"
      class="d-flex align-items-center"
    >
      <i
        v-tooltip="{ placement: 'left' }"
        class="hi-right"
        title="This shift continues into the next day"
      />
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import TimeOffRequestBambooHrBadge from '~/components/time_off/TimeOffRequestBambooHrBadge.vue';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'DayViewEvent',
  components: { TimeOffRequestBambooHrBadge },
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapInertiaProps({
      timeZone: ({ time_zone: timeZone }) => timeZone.for,
    }),
    eventDetails() {
      return this.type === 'Shift' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
